module.exports = __webpack_public_path__ + "static/media/ComingSoon.d25690f8.png";